export class AttachmentTable {
    name: string;
    size: number;
    type: string;
    url: string;
    isImage: boolean;
    commentLogId: number | undefined;
}

export enum IconAccordingToType {
    AUDIO_FILE = "/assets/images/mp3_66.svg",
    VIDEO_FILE = "/assets/images/video_66.svg",
    PDF_FILE = "/assets/images/pdf_66.svg",
    EXCEL_FILE = "/assets/images/excel_66.svg",
    WORD_FILE = "/assets/images/word_66.svg",
    POWERPOINT_FILE = "/assets/images/ppt_66.svg",
    IMAGE_FILE = "/assets/images/image-document.svg",
    TEXT_FILE = "/assets/images/other_66.svg",
    OTHER_FILE = "/assets/images/other_66.svg",
}

export enum FILE_TYPE {
    AUDIO = "AUDIO_FILE",
    VIDEO = "VIDEO_FILE",
    PDF = "PDF_FILE",
    EXCEL = "EXCEL_FILE",
    WORD = "WORD_FILE",
    POWERPOINT = "POWERPOINT_FILE",
    IMAGE = "IMAGE_FILE",
    TEXT = "TEXT_FILE",
    OTHER = "OTHER_FILE",
    UNKNOWN = "UNKNOWN_FILE",
}

export class FileUploadTimeoutConstants {
    static readonly BASE_UPLOAD_TIMEOUT_MS = 120_000;   // 2 min for server scanning
    static readonly TIMEOUT_PER_MB_MS = 10_000;         // +10 sec per MB
    static readonly BYTES_PER_MB = 1024 * 1024;

    static forPayload(totalBytes: number): number {
        const totalMb = Math.ceil(totalBytes / this.BYTES_PER_MB);
        return this.BASE_UPLOAD_TIMEOUT_MS + totalMb * this.TIMEOUT_PER_MB_MS;
    }
}